import { useTranslation } from 'react-i18next'
import {
  TRUST_COMPARE_ROWS,
  trustCompareRowLabelKey,
  trustCompareStatusLabelKey,
  type TrustCompareStatus,
} from '@redevicer/shared'
import TrustInspection47 from './TrustInspection47'

function CompareStatus({ status }: { status: TrustCompareStatus }) {
  const { t } = useTranslation()
  const label = t(trustCompareStatusLabelKey(status))
  const symbol = status === 'no' ? '✕' : '✓'

  return (
    <span
      className={`vc-trust-compare__status vc-trust-compare__status--${status}`}
      aria-label={label}
      title={label}
    >
      {symbol}
    </span>
  )
}

export default function TrustBar() {
  const { t } = useTranslation()

  return (
    <section
      id="vc-trust-bar"
      className="vc-section vc-section--centered vc-section--trust"
      aria-labelledby="vc-trust-compare-heading"
    >
      <TrustInspection47 />
      <div className="vc-trust-compare-intro">
        <h3 id="vc-trust-compare-heading" className="vc-section-title">
          {t('trust.compare.sectionTitle')}
        </h3>
        <p className="vc-section-lead">{t('trust.compare.sectionLead')}</p>
      </div>
      <div className="vc-trust-bar">
        <table className="vc-trust-compare" role="table">
          <caption className="sr-only">{t('trust.compare.sectionTitle')}</caption>
          <thead>
            <tr>
              <th scope="col" className="vc-trust-compare__feature-head">
                <span className="sr-only">{t('trust.compare.sectionTitle')}</span>
              </th>
              <th scope="col" className="vc-trust-compare__col-head">
                {t('trust.compare.colMarketplace')}
              </th>
              <th scope="col" className="vc-trust-compare__col-head vc-trust-compare__col-head--verified">
                {t('trust.compare.colVerified')}
              </th>
            </tr>
          </thead>
          <tbody>
            {TRUST_COMPARE_ROWS.map((row) => (
              <tr key={row.id} className="vc-trust-compare__row">
                <th scope="row" className="vc-trust-compare__feature">
                  {t(trustCompareRowLabelKey(row.id))}
                </th>
                <td className="vc-trust-compare__cell">
                  <CompareStatus status={row.marketplace} />
                </td>
                <td className="vc-trust-compare__cell vc-trust-compare__cell--verified">
                  <CompareStatus status={row.verified} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
